import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type RiskLevel = "DE_BAZA" | "IMPORTANT" | "ESENTIAL" | "NEEVALUAT";

type RiskLevelBadgeProps = {
  riskLevel?: RiskLevel | null;
  className?: string;
};

const LABELS: Record<RiskLevel, string> = {
  DE_BAZA: "de Bază",
  IMPORTANT: "Important",
  ESENTIAL: "Esențial",
  NEEVALUAT: "Neevaluat",
};

const COLOR_CLASSES: Record<RiskLevel, string> = {
  DE_BAZA: "bg-ds-green-100 text-ds-green-600 hover:bg-ds-green-100",
  IMPORTANT: "bg-ds-amber-100 text-ds-amber-800 hover:bg-ds-amber-100",
  ESENTIAL: "bg-ds-red-200 text-ds-red-700 hover:bg-ds-red-200",
  NEEVALUAT: "bg-ds-border-200 text-ds-text-500 hover:bg-ds-border-200",
};

export function RiskLevelBadge({ riskLevel, className }: RiskLevelBadgeProps) {
  const effective: RiskLevel = riskLevel ?? "NEEVALUAT";
  return (
    <Badge
      className={cn(
        "rounded-sm text-xs px-2 py-0.5",
        COLOR_CLASSES[effective],
        className
      )}
    >
      Risc: {LABELS[effective]}
    </Badge>
  );
}
